import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useMatch } from 'react-router-dom';
import { ViewOption, ViewSwitch } from '../Controls';
import { PageTitle } from '../Page';
import { getRules } from './actions';
import { selectRulePages, selectRuleSections, selectRulesLoaded } from './selectors';
import RulesBook from './RulesBook';
import RulesText from './RulesText';
import ImageViewer from './ImageViewer';
import { ImageViewerContext } from './viewerContext';
import { RulesHeader, RulesPage } from './styled';

/** The printed rulebook: the photographed booklet at /rules, its transcribed text at /rules/text. */
const Rules = () => {
  const dispatch = useDispatch();
  const loaded = useSelector(selectRulesLoaded);
  const sections = useSelector(selectRuleSections).toJS();
  const pages = useSelector(selectRulePages).toJS();
  const showText = !!useMatch('/rules/text');
  const [viewing, setViewing] = useState(null);
  const openImage = useCallback((src, alt) => setViewing({ src, alt }), []);
  const closeImage = useCallback(() => setViewing(null), []);

  // A route change resets the store (appReset), and switching Book and Text keeps this component mounted, so
  // fetch whenever the rules aren't loaded rather than only on mount.
  useEffect(() => {
    if (!loaded) {
      dispatch(getRules());
    }
  }, [loaded, dispatch]);

  return (
    <ImageViewerContext.Provider value={openImage}>
      <RulesPage $wide={!showText}>
        <RulesHeader>
          <PageTitle>Rules</PageTitle>
          <ViewSwitch role="group" aria-label="Rules view">
            <ViewOption as={Link} to="/rules" $on={!showText}>Book</ViewOption>
            <ViewOption as={Link} to="/rules/text" $on={showText}>Text</ViewOption>
          </ViewSwitch>
        </RulesHeader>
        {showText
          ? <RulesText sections={sections} loaded={loaded} />
          : <RulesBook pages={pages} sections={sections} />}
        {viewing && <ImageViewer src={viewing.src} alt={viewing.alt} onClose={closeImage} />}
      </RulesPage>
    </ImageViewerContext.Provider>
  );
};

export default Rules;
